export default __webpack_public_path__ + "static/media/Insider_Trading_Policy_Amendment.7bc95003.pdf";